export const KEY_CODES = {
  ENTER_CHAR_CODE: 13,
};
